module.exports = __webpack_public_path__ + "static/media/profileFemale.3abe25d1.svg";